import axios from 'axios';
import { Module } from "vuex";
import {SComponentType} from "@/components/dto/SComponentType";
import {SGroup} from "@/components/dto/SGroup";
import {SComponents} from "@/components/dto/SComponents";
import {ObjUtils} from "@/components/utils/ObjUtils";


const Components: Module<any, any> = {
    state: {
        status: '',
        components: [],
        componentTypes: [],
        componentGroups: []
    },
    //@ts-ignore
    mutations: {
        add_component_request(state: any){
            state.status = 'loading';
        },
        add_component(state: any){
            state.status = 'success';
        },
        load_components_request(state: any){
            state.status = 'loading';
        },
        load_components(state: any, components: SComponents[]){
            state.status = 'success';
            state.components = components;
        },
        load_component_types_request(state: any){
            state.status = 'loading';
        },
        load_component_types(state: any, componentTypes: SComponentType[]){
            state.status = 'success';
            state.componentTypes = componentTypes;
        },
        load_component_groups_request(state: any){
            state.status = 'loading';
        },
        load_component_groups(state: any, componentGroups: SGroup[]){
            state.status = 'success';
            state.componentGroups = componentGroups;
        }
    },
    actions: {
        async addcomponent({commit}, component){
            commit('add_component_request');
            let res = await axios.post('http://localhost:5000/api/components/add', component);
            if(res.data.success !== undefined){
                commit('add_component');
            }
            return res;
        },
        async loadComponents({commit}, searchCriteria){
            commit('load_components_request');
            let res = await axios.post('http://localhost:5000/api/components/load', searchCriteria);
            commit('load_components', ObjUtils.parseJsonString(JSON.stringify(res.data)));
            return res;
        },
        async loadComponentTypes({commit}){
            commit('load_component_types_request');
            let res = await axios.get('http://localhost:5000/api/components/types');
            commit('load_component_types', ObjUtils.parseJsonString(JSON.stringify(res.data)));
            return res;
        },
        async loadComponentGroups({commit}){
            commit('load_component_groups_request');
            let res = await axios.get('http://localhost:5000/api/components/groups');
            commit('load_component_groups', ObjUtils.parseJsonString(JSON.stringify(res.data)));
            return res;
        },
    },
    getters: {
        components: state => state.components,
        componentTypes: state => state.componentTypes,
        componentGroups: state => state.componentGroups
    },
};

export default Components;
